module.exports = __webpack_public_path__ + "img/puzzle3_1.24a45b81.jpg";